export const OWA_APP_ID = '00000002-0000-0ff1-ce00-000000000000';
export const DriveId: string = 'driveId';
export const ItemId: string = 'itemId';

export const COMPOSE_ONLY_FLUID_KEEP_BODY = 'owaFluidKeepBodyOnSend';
export const COMPOSE_FLUID_PLACEHOLDER_ID = 'fluidPlaceholder';

export const OUTLOOK_APP_NAME = 'Outlook';
export const OUTLOOK_WEB_APP_NAME = 'Outlook_Web_App';
export const OWA_APP_PLATFORM = 'Web';
export const CH2_APP_NAME = 'OneNoteMeetings';
export const FLUID_ENTITY_TYPE = 'OWAFluid';
export const FLUID_CHANGE_SOURCE = 'fluid';
export const FLUID_CONTAINER = 'fluidContainer';
export const FLUID_HERO_MENU_ID = 'FLUID_HERO_MENU_ID';
